import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { actionBtnTypes, CrudComponent } from "../../../../../components/boda-boda/CRUD/CrudComponent";
import { getManifestListAPI } from "../../../../../config/boda-boda/apiUrls.config";
import { CreateUI, PickRequestFilterUI } from "../common-includes/common-includes";
import { modalTypes } from "../../../../../components/boda-boda/Modal/config/model.config";
import { dateObjectToString } from "../../../../../helpers/boda-boda/common-helpers/dateTime.helpers";
import CreateManifestBtn from "../common-includes/CreateManifestBtn";
import { requestAPICallFn } from "../../../../../store/boda-boda/core/actions";
import { SendRequestUIMessage, SendRequestUIBtn } from "../common-includes/SendRequestUI";
import { mapStatusesNames } from "../../../../../config/boda-boda/db_config/db_status.config";
import { formatToDateHelper, isEmptyValue } from "../../../../../helpers/boda-boda/common-helpers/common.helpers";
import { ManifestPrintBody, PrintManifestBtn } from "../common-includes/PrintUI";
import { setFormErrorFn } from "../../../../../store/boda-boda/form/actions";


class DraftRequestComponent extends Component {
    render() {
        let { history, location } = this.props;

        return (
            <Fragment>
                <CrudComponent
                    title={"Drafts"}
                    apiURL={`${getManifestListAPI.url}/compressed?page=1&limit=20&status=DRAFT`}
                    dataTableStateKey={getManifestListAPI.key}
                    isFilter={true}
                    filterFromComponent={PickRequestFilterUI}
                    defaultFilterFormObject={{
                        pickupDateFrom: null,
                        pickupDateTo: null,
                        code: "",
                        articleId: "",
                        locationPickId: ""
                    }}
                    clearErrors={() => {
                        const { setFormErrorFn } = this.props;
                        setFormErrorFn("manifestListAPIKey_search", []);
                    }}
                    onRebuildFilterObjFn={(filterData) => {
                        const data = filterData;
                        let { setFormErrorFn } = this.props;
                        const errors = [];

                        if (new Date(filterData.pickupDateFrom) > new Date(filterData.pickupDateTo)) {
                            errors.push({
                                "property":"pickupDateTo",
                                "error":"The Date To field should not be less than the Date From field"
                            });
                        }

                        if(errors.length > 0 ){
                            setFormErrorFn("manifestListAPIKey_search", errors);
                            return ;
                        }else{
                            setFormErrorFn("manifestListAPIKey_search", null);
                        }

                        if (!isEmptyValue(filterData.pickupDateTo)) {
                            data["pickupDateTo"] = formatToDateHelper(filterData.pickupDateTo);
                        }

                        if (!isEmptyValue(filterData.pickupDateFrom)) {
                            data["pickupDateFrom"] = filterData.pickupDateFrom.toISOString();
                        }

                        return data;
                    }}
                    isSetCreateAction={true}
                    createActionProps={{
                        actionType: actionBtnTypes.create,
                        isSetModel: true,
                        modalProps: {
                            modalTitle: "Create Pick Request",
                            modalType: "",
                            modalBodyComponent: CreateUI,
                            modalFooterComponent: CreateManifestBtn,
                            isSetClose: true,
                            isSetFooterClose: true,
                            parentToModelProps: {
                                formKey: "_create",
                                uiType: "create",
                            },
                        }
                    }}
                    tableHeaderList={[
                        { displayName: "Manifest Code", key: "code" },
                        { displayName: "Created Time", key: "createdAt", onPrintFn: (rawData) => (rawData.createdAt) ? dateObjectToString(rawData.createdAt, "YY-mm-dd HH:MM:II") : "-" },
                        { displayName: "To be Picked Up On", key: "pickAt", onPrintFn: (rawData) => (rawData.pickAt) ? dateObjectToString(rawData.pickAt, "YY-mm-dd") : "-" },
                        { displayName: "Pick Up Location", key: "locationPick.name" },
                        {
                            displayName: "Status", key: "status", onPrintFn: (rawData) => {
                                return mapStatusesNames[rawData.status];
                            }
                        }
                    ]}
                    actionList={[
                        {
                            actionType: actionBtnTypes.view,
                            isSetModel: false,
                            actionBtn: {
                                onClickBtnFn: (rawData) => history.push(`/pick-request/${location.pathname.split('/')[2]}/view/${rawData.id}`),
                            }
                        },
                        {
                            actionType: actionBtnTypes.edit,
                            isSetModel: false,
                            actionBtn: {
                                onClickBtnFn: (rawData) => history.push(`/pick-request/drafts/edit/${rawData.id}`),
                            }
                        },
                        {
                            actionType: actionBtnTypes.edit,
                            isSetModel: true,
                            actionBtn: {
                                tooltip: "Send Request",
                                color: "success",
                                icon: "fas fa-share",
                                btnText: "send",
                                //onClickBtnFn: (rawData) => this.sendRequestFn(rawData)
                            },
                            modalProps: {
                                modalTitle: "Please Confirm",
                                modalType: "",
                                modalBodyComponent: SendRequestUIMessage,
                                modalFooterComponent: SendRequestUIBtn,
                                isSetClose: true,
                                isSetFooterClose: true,
                                parentToModelProps: {
                                    type: "datatable"
                                },
                                closeBtnName: "No"
                            },
                            checkBeforeActionRenderFn: (rawData) => {
                                return rawData.rowData.status === "DRAFT" && rawData.rowData.pickRequestCsvUrl === null;
                            }
                        },
                        {
                            actionType: actionBtnTypes.other,
                            isSetModel: true,
                            actionBtn: {
                                icon: "fas fa-print",
                                color: "primary",
                                tooltip: "Print",
                                btnText: "print"
                            },
                            modalProps: {
                                modalTitle: "Manifest",
                                modalType: modalTypes.large,
                                modalBodyComponent: ManifestPrintBody,
                                modalFooterComponent: PrintManifestBtn,
                                isSetClose: true,
                                isSetFooterClose: true,
                            }
                        }
                    ]}
                />
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        formState: state.FormData
    };
};

const DraftRequest = withRouter(DraftRequestComponent);

export default connect(mapStateToProps, { requestAPICallFn, setFormErrorFn })(DraftRequest);
